import React from "react";
import { Link } from "react-router-dom";
import { formatToDate } from "../../master/FormatToDateTime";
import { EnquiryStatusBadge } from "../components/Master";
import usePrivateLink from "../../config/usePrivateLink";

export default function BasicDetail({ data }) {
  const hasAccess = usePrivateLink();
  return (
    <div className="container-fluid px-0">
      <div className="row g-3">
        {/* LEFT PROFILE */}
        <div className="col-lg-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body text-center">
              <div
                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                style={{
                  width: "90px",
                  height: "90px",
                  fontSize: "32px",
                  fontWeight: "700",
                }}
              >
                {data?.student_name?.charAt(0)?.toUpperCase()}
              </div>

              <h5 className="fw-bold mb-1">{data?.student_name}</h5>

              <div className="text-muted small mb-2">#{data?.enquiry_no}</div>

              <div className="mb-3">{EnquiryStatusBadge(data?.status)}</div>

              <hr />

              <div className="text-start">
                <div className="mb-3">
                  <small className="text-muted d-block">Mobile</small>
                  <strong>{data?.mobile || "-"}</strong>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block">Email</small>
                  <strong>{data?.email || "-"}</strong>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block">Counselor</small>
                  <strong>{data?.counselor?.name || "-"}</strong>
                </div>

                <div>
                  <small className="text-muted d-block">Next Followup</small>
                  <strong>{formatToDate(data?.next_followup_date)}</strong>
                </div>
              </div>

              {hasAccess("/enquiry/update") && (
                <Link
                  to={`/enquiry/update?id=${data?.id}`}
                  className="btn btn-primary w-100 mt-4"
                >
                  <i className="ri-edit-line me-1"></i>
                  Update Enquiry
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-9">
          <div className="row g-3">
            {/* PERSONAL DETAILS */}
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Personal Details</h6>
                </div>

                <div className="card-body">
                  <div className="row">
                    <Detail label="Father Name" value={data?.father_name} />
                    <Detail label="Gender" value={data?.gender} />
                    <Detail label="Category" value={data?.category} />
                    <Detail label="Hostel" value={data?.hostel_status} />
                  </div>
                </div>
              </div>
            </div>

            {/* COURSE DETAILS */}
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Academic Details</h6>
                </div>

                <div className="card-body">
                  <Info title="Course" value={data?.course?.title} />

                  <Info title="Medium" value={data?.medium} />

                  <Info title="Education" value={data?.last_eduction} />

                  <Info title="Institute" value={data?.last_institute_name} />
                </div>
              </div>
            </div>

            {/* ENQUIRY DETAILS */}
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Enquiry Details</h6>
                </div>

                <div className="card-body">
                  <Info
                    title="Enquiry Date"
                    value={formatToDate(data?.enquiry_date)}
                  />

                  <Info
                    title="Created By"
                    value={`${data?.creator_by?.name || ""} ${
                      data?.creator_by?.registration_no
                        ? `(${data?.creator_by?.registration_no})`
                        : ""
                    }`}
                  />

                  <Info title="Reference" value={data?.reference_detail} />
                </div>
              </div>
            </div>

            {/* ADDRESS */}
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Address</h6>
                </div>

                <div className="card-body">
                  <p className="mb-0">
                    {[data?.village, data?.district, data?.state, data?.zipcode]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </div>
              </div>
            </div>

            {/* FOLLOWUP */}
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Follow-up</h6>
                </div>

                <div className="card-body">
                  <div className="timeline">
                    <div className="mb-3">
                      <small className="text-muted">Last Followup</small>
                      <div className="fw-semibold">
                        {formatToDate(data?.followup_date)}
                      </div>
                    </div>

                    <div className="mb-3">
                      <small className="text-muted">Next Followup</small>
                      <div className="fw-semibold text-primary">
                        {formatToDate(data?.next_followup_date)}
                      </div>
                    </div>

                    <div>
                      <small className="text-muted">Notes</small>
                      <div>{data?.note || "-"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FOLLOWUP HISTORY PLACEHOLDER */}
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header ">
                  <h6 className="mb-0 fw-bold">Follow-up Timeline</h6>
                </div>

                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <i className="ri-user-add-line text-success me-2"></i>
                    <span>
                      Enquiry Created on {formatToDate(data?.enquiry_date)}
                    </span>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <i className="ri-phone-line text-primary me-2"></i>
                    <span>
                      Last Followup : {formatToDate(data?.followup_date)}
                    </span>
                  </div>

                  <div className="d-flex align-items-center">
                    <i className="ri-calendar-event-line text-warning me-2"></i>
                    <span>
                      Next Followup : {formatToDate(data?.next_followup_date)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Detail = ({ label, value }) => (
  <div className="col-md-3 col-sm-6 mb-3">
    <small className="text-muted d-block">{label}</small>
    <div className="fw-semibold">{value || "-"}</div>
  </div>
);

const Info = ({ title, value }) => (
  <div className="mb-3">
    <small className="text-muted d-block">{title}</small>
    <div className="fw-semibold">{value || "-"}</div>
  </div>
);
